<div class="card mb-2 wow detalle-cliente" [ngClass]="{'emp_recibidos__details--hidden': !visible}">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">
      <h4>
        Vista Importación
      </h4>
    </div>
  </div>
  <div class="card-body justify-content-between">
    <!-- LEYENDA DE COLORES -->
    <ul class="list-group list-group-horizontal mb-2">
      <li class="list-group-item p-1">
        <mdb-icon [class]="classColorNoProcesado" fas icon="circle"></mdb-icon>
        Importación sin procesar
      </li>
      <li class="list-group-item p-1">
        <mdb-icon [class]="classColorProcesado" fas icon="circle"></mdb-icon>
        Importación procesada
      </li>
      <li class="list-group-item p-1">
        <mdb-icon [class]="classColorBloqueado" fas icon="circle"></mdb-icon>
        Importación Bloqueada
      </li>
    </ul>
    
    <div class="table-responsive" *ngIf="listaDocumentos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col" style="width: 1rem; min-width: 1rem; max-width: 2rem;">
              <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
            </th>
            <th scope="col">Fecha</th>
            <th scope="col">Folio</th>
            <th scope="col">Rut</th>
            <th scope="col">Detalle</th>
            <th scope="col">Monto Neto</th>
            <th scope="col">Monto Exento</th>
            <th scope="col">Impto.Adic</th>
            <th scope="col">Total Bruto</th>
            <th scope="col">Mes-Año sgte.</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaDocumentos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let doc of listaDocumentos">
            <td>
              <!--Azul-->
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0"></span>
              <!--Rojo-->
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null"></span>
              <!--Negro-->
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false">
                <mdb-checkbox [checked]="doc.additionalInfo.checked"
                  (change)='checkDetalle(doc.additionalInfo, $event)'>
                </mdb-checkbox></span>
              <!-- <ng-container *ngIf="doc.envio_rec"> -->
              <!-- </ng-container> -->
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.fecha |
                fecha}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.fecha |
                fecha}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado">{{doc.fecha | fecha}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.folio |
                numerico}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.folio |
                numerico}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado">{{doc.folio | numerico}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.rutFormato |
                rut}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.rutFormato |
                rut}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado">{{doc.rutFormato | rut}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.razon_social}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.razon_social}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false" [class]="classColorNoProcesado">{{doc.razon_social}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.monto_neto |
                numerico}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.monto_neto |
                numerico}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false" [class]="classColorNoProcesado">{{doc.monto_neto | numerico}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.monto_exento |
                numerico}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.monto_exento
                | numerico}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false" [class]="classColorNoProcesado">{{doc.monto_exento | numerico}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0"
                [class]="classColorProcesado">{{doc.impuesto_adicional | numerico}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null"
                [class]="classColorBloqueado">{{doc.impuesto_adicional | numerico}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado">{{doc.impuesto_adicional | numerico}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0" [class]="classColorProcesado">{{doc.total_bruto |
                numerico}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado">{{doc.total_bruto |
                numerico}}</span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado">{{doc.total_bruto | numerico}}</span>
            </td>
            <td>
              <span *ngIf="doc.mes_recepcion != null && doc.mes_recepcion > 0"
                [class]="classColorProcesado">{{doc.mes_recepcion}}</span>
              <span *ngIf="doc.no_procesado === true && doc.mes_recepcion === null" [class]="classColorBloqueado"></span>
              <span *ngIf="(doc.mes_recepcion === null || doc.mes_recepcion === 0) && doc.no_procesado === false"
                [class]="classColorNoProcesado"></span>
            </td>
            <td class="text-center">
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="showModalAgregarDocumentoRecibido(doc)" mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
              <ng-container *ngIf="!doc.additionalInfo.loadingPdf">
                <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                  (click)="downloadDocumentoPDF(doc)" mdbTooltip="Ver PDF" placement="right">
                  <mdb-icon fas icon="file-pdf"></mdb-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="doc.additionalInfo.loadingPdf">
                <mdb-spinner spinnerColor="blue" spinnerType="small"></mdb-spinner>
              </ng-container>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaDocumentos?.length > 0"></app-pagination>
      </table>
    </div>

    <div class="card-footer text-muted filtros-right" style="border-top: 1px solid #dee2e6;" *ngIf="areSelected">
      <div></div>
      <app-api-button2 (click3)="showModalConfirmPeriodoGestion()" [processing]="processing">
        Procesar a ERP
      </app-api-button2>
      <button mdbBtn type="button" size="sm" color="danger" mdbWavesEffect (click)="showModalConfirmNoProcesar()">
        No Procesar
      </button>
    </div>

  </div>
</div>

<app-modal-confirm></app-modal-confirm>

<app-modal-confirm-periodo-gestion></app-modal-confirm-periodo-gestion>

<app-modal-add-doc-recibido (onExecuteBuscar)="getItemToSearch($event)"></app-modal-add-doc-recibido>

<app-modal-doc-procesado-resultado></app-modal-doc-procesado-resultado>

<app-empresas-recibidos-modal-observaciones-no-procesadas
  (onResponse)="onResponse()"></app-empresas-recibidos-modal-observaciones-no-procesadas>
